import { Text } from '@mantine/core';
import { keyBy } from 'lodash/fp';
import React from 'react';

import { AuditLogType } from '@portals/types';

interface PartnerAcceptedInvitationProps {
  auditLog: AuditLogType;
}

export function PartnerAcceptedInvitation({
  auditLog,
}: PartnerAcceptedInvitationProps) {
  const paramsMap = keyBy('name', auditLog.params);
  const partnerParam = paramsMap['partner'];

  return (
    <Text size="sm">
      Accepted invitation from:{' '}
      <Text span weight={700}>
        {partnerParam.display_name}
      </Text>
    </Text>
  );
}
